var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.shouldRenderKeelearningContentCard)?_c(_setup.KeelearningContentCard,{attrs:{"href":_vm.href,"morph-type":_setup.parsedURL.morphType,"foreign-id":_setup.parsedURL.foreignId,"user-ids":_vm.userIds}},[_vm._t("default")],2):_c(_setup.ExternalA,{attrs:{"href":_vm.href,"target":_vm.target}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }